import { Environment } from "./environment.interface";

export const environment: Environment = {
	production: false,
	brands: {
		enelx: {
			globalNavUrl: 'https://global-nav.dev-svcs.enelx.net/api/v1',
			baseUrl: 'https://flex-home.dev-apps.enelx.net/v1'
		}
	},
	cdn: 'https://cdn.dev-apps.enelx.net',
	defaults: {
		brand: 'enelx',
		locale: 'en-us',
		apiLocale: 'en_US'
	},
	externalUrls: {
		activeEvents: 'https://active-dispatches.dev-apps.enelx.net',
		com: 'https://customer-offers.dev-apps.enelx.net',
		trends: 'https://trends.dev-apps.enelx.com',
	}
};
